import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Linkedin } from 'lucide-react';
export function Founder() {
  return <section id="founder" className="py-24 lg:py-40 bg-soft-white relative overflow-hidden" data-id="element-61">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-62">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center" data-id="element-63">
          <FadeIn direction="right" className="lg:col-span-5 relative" data-id="element-64">
            <div className="relative aspect-[4/5] max-w-md mx-auto lg:mx-0" data-id="element-65">
              <div className="absolute inset-0 overflow-hidden" data-id="element-66">
                <img src="https://cdn.magicpatterns.com/uploads/qDb4u5WXEcmBdLNSsUyJMP/IMG_5943.png" alt="Stephanie Martin, Founder of LeadHERship Equity" className="w-full h-full object-cover" data-id="element-67" />
                <div className="absolute inset-0 bg-gradient-to-tr from-deep-azure/15 via-transparent to-transparent mix-blend-multiply" data-id="element-68"></div>
              </div>
              {/* Decorative editorial frame */}
              <div className="absolute top-6 -right-6 w-full h-full border border-golden-yellow/40 -z-10 hidden md:block" data-id="element-69"></div>
              <div className="absolute -bottom-6 -left-6 w-32 h-32 border-l-2 border-b-2 border-vivid-orange/60 hidden md:block" data-id="element-70"></div>
            </div>
          </FadeIn>

          <div className="lg:col-span-7" data-id="element-71">
            <FadeIn data-id="element-72">
              <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-vivid-orange mb-8" data-id="element-73">
                Founder
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-medium leading-[1.05] text-deep-azure mb-2" data-id="element-74">
                Stephanie Martin
              </h2>
              <p className="text-xl md:text-2xl font-display italic font-light text-dark-azure mb-10" data-id="element-75">
                HRM-certified · Strategic Leadership · Ecosystem Architect
              </p>

              <div className="editorial-rule w-24 mb-10" data-id="element-76"></div>

              <div className="space-y-5 text-lg text-charcoal-navy/80 leading-relaxed mb-10 font-light" data-id="element-77">
                <p data-id="element-78">
                  After supporting 225+ founders and leaders across two decades
                  of programming, mentorship, and strategic advisory, Stephanie
                  founded LeadHERship Equity to address the gap she kept seeing
                  — organizations and founders had ambition, but lacked the
                  strategic infrastructure to translate it into measurable
                  advancement.
                </p>
                <p className="font-display italic text-xl text-deep-azure" data-id="element-79">
                  "We don't need more inspiration. We need infrastructure. We
                  need ecosystems that translate ambition into measurable
                  outcomes."
                </p>
                <p data-id="element-80">
                  Today, LeadHERship Equity sits at the intersection of
                  strategic infrastructure, ecosystem intelligence, and the
                  future of equitable leadership.
                </p>
              </div>

              <a href="#" className="inline-flex items-center gap-2 text-deep-azure hover:text-vivid-orange font-medium text-sm tracking-[0.05em] uppercase transition-colors" data-id="element-81">
                <Linkedin className="w-4 h-4" data-id="element-82" />
                Connect on LinkedIn
              </a>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}